<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import DxButton from 'devextreme-vue/button';
import DxToolbar, { DxItem } from 'devextreme-vue/toolbar';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver-es';
import { exportDataGrid } from 'devextreme/excel_exporter';
import Loader from "../components/loader";
import CustomStore from 'devextreme/data/custom_store';
import api from "@/axios";

import {
  DxDataGrid,
  DxColumn,
  DxColumnChooser,
  DxColumnFixing,
  DxSelection,
  DxExport,
  DxStateStoring,
  DxGroupPanel, DxGrouping,
  DxPager, DxFilterRow, DxRemoteOperations
} from 'devextreme-vue/data-grid';
import Swal from "sweetalert2";
import {getBaseUrl} from "@/helpers/baseUrl";


export default {

  components: { Layout, PageHeader, DxButton,
    DxDataGrid, DxColumn, DxColumnChooser, DxColumnFixing, DxSelection, DxExport,
    DxStateStoring, DxGroupPanel, DxGrouping, DxToolbar, DxItem, DxPager,  DxFilterRow, DxRemoteOperations,
    Loader,
  },
  data() {
    return {
      title: "Eventos de Rastreio",
      items: [
        {
          text: "Cadastro",
          href: "/"
        },
        {
          text: "Eventos de Rastreio",
          active: true
        }
      ],
      dataList: null,
      totalList: 0,
      updating: false,
      updatingInst: false,
      showModalTrackerEvent: false,
      submittedTrackerEvent: false,
      trackerEventData: {},
      errosValid: null,
      showModalInstancia: false,
      zapInstanciaData: {},
      submittedInstancia: false,
      qrCodeLogin: null
    };
  },

  watch: {
    'zapInstanciaData.nome': {
      handler(newVal) {
        let re = /[^A-Z0-9]/gi;
        this.zapInstanciaData.nome = newVal.replace(re, '').toUpperCase()
      }
    }
  },

  computed: {
    dataGrid: function() {
      return this.$refs.dataGridRefKey.instance
    }
  },

  mounted() {
    console.log('mounted mov-list_0')
    this.atualizaDataList()
  },

  methods: {

    deleteInstancia(){
      console.log('deleteInstancia')
      this.showModalInstancia = false
      this.updating = true
      api.get(`${getBaseUrl()}api/delinst`, {
        params: {
          'nome': this.zapInstanciaData.nome
        }
      }).then(response => {
        console.log('response.data')
        console.log(response)
        this.updating = false
        if (response.data.error) {
          Swal.fire({
            position: "top-end",
            icon: "error",
            title: response.data.response.message,
            showConfirmButton: false,
            timer: 3500
          })
        } else {
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Exclusão realizada com sucesso.",
            showConfirmButton: false,
            timer: 3500
          })
        }
      })

    },


    onRowDblClick(row) {
      console.log('onRowDblClick')
      console.log(row)
      this.zapInstanciaData = {
        id: row.data.id,
        nome: row.data.name
      }
      this.qrCodeLogin = null
      this.submittedInstancia = false
      this.showModalInstancia = true
    },


    confInstancia(){
      console.log('confInstancia')
      console.log(this.zapInstanciaData.nome)
      this.submittedInstancia = true
      if (this.zapInstanciaData.nome) {
        this.updatingInst = true
        api.get(`${getBaseUrl()}api/criarinst`, {
          params: {
            'nome': this.zapInstanciaData.nome
          }
        }).then(response => {
          console.log('response.data')
          console.log(response)
          this.updatingInst = false
          if (response.data.error) {
            Swal.fire({
              position: "top-end",
              icon: "error",
              title: response.data.response.message,
              showConfirmButton: false,
              timer: 3500
            })
          } else {
            this.zapInstanciaData.id = response.data.instance.instanceId
            this.qrCodeLogin = response.data.qrcode.base64
          }
        })
      }
    },

    criarInstancia(){
      console.log('criarInstancia')
      this.zapInstanciaData = {}
      this.qrCodeLogin = null
      this.submittedInstancia = false
      this.showModalInstancia = true
    },

    carregouGrid(e){
      console.log('carregouGrid')
      this.title = '(' + e.component.totalCount() + ') Instâncias WhatsApp'
    },

    atualizaDataList(){
      console.log('atualizaDataList')
      this.dataList = new CustomStore({
        key: "id",
        load: function(loadOptions){
          let queryArray = []
          if (loadOptions['filter']) {
            if (loadOptions['filter'][1] === 'and' || loadOptions['filter'][1] === 'or') {
              loadOptions['filter'].forEach((value) => {
                // console.log('value_filter')
                // console.log(value)
                // console.log(value[0])
                // console.log(typeof (value))
                if (typeof (value) === "object") {
                  queryArray.push({
                    cmp: value[0],
                    opr: value[1],
                    val: value[2],
                  })
                }
              })
            } else {
              queryArray.push({
                cmp: loadOptions['filter'][0],
                opr: loadOptions['filter'][1],
                val: loadOptions['filter'][2],
              })
            }
          }
          const paramsReq = {
            'skip': loadOptions['skip'],
            'take': loadOptions['take'],
            'filter': queryArray,
            'sort': loadOptions['sort'],
          }

          console.log('paramsReq')
          console.log(paramsReq)

          return api.get(`${getBaseUrl()}api/indexinst`, {
            params: paramsReq
          }).then(response => {
            console.log('response.data')
            console.log(response)
            return {
              data: response.data[0],
              totalCount: response.data[1],
            }
          })
        },
      })

    },

    onCellPrepared(e) {
      if (e.rowType === "data") {
        if (e.column.dataField === "status") {
          // console.log('onCellPrepared')
          // console.log(e.data.status)
          const valStatus = e.data.status
          let corStatus = 'rgba(78,59,0,0.5)'
          switch (valStatus) {
            case 'A':
              corStatus = 'rgba(33,78,0,0.5)'
              break
            case 'I':
              corStatus = 'rgba(146,20,0,0.5)'
              break
          }
          e.cellElement.style.cssText = `color: white; background-color: ${corStatus}`;
        }
      }
    },


    onExporting(e){
      console.log('onExporting')
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet('plan1');
      exportDataGrid({
        component: e.component,
        worksheet,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), this.title + '.xlsx');
        });
      });
      e.cancel = true;
    },

    refeFormTable(){
      console.log('refeFormTable')
      this.dataGrid.state(null);

    },

    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2});
      }
      return 0.00;
    },

    nomeStatus(e) {
      if (e.value === "A") {
        return 'Ativo'
      } else {
        return 'Inativo'
      }
    },
  },
};

</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <b-alert v-for="(erro, i) in errosValid" :key="`alerta-${i}`"   show dismissible variant="danger" >
      <i class="mdi mdi-alert me-2"></i>Pendente validação de campo: {{ erro.titulo }} -- {{ erro.mensagem[0] }} --
      favor ajustar e tentar novamente.
    </b-alert>
    <div>

      <DxToolbar>
        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="refresh"
              hint="Redefinir formatação de tabela para padrão"
              :on-click="refeFormTable"/>
        </DxItem>
        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="plus"
              text="Nova Instância"
              :on-click="criarInstancia"/>
        </DxItem>
      </DxToolbar>
    </div>

    <Loader v-if="updating" style="min-height: 300px;">
    </Loader>

    <div class="mt-2" v-if="!updating">
      <DxDataGrid
          ref="dataGridRefKey"
          :data-source="dataList"
          :show-borders="true"
          :focused-row-enabled="true"
          :column-auto-width="true"
          :show-row-lines="true"
          :allow-column-reordering="true"
          :allow-column-resizing="true"
          :row-alternation-enabled="true"
          @cell-prepared="onCellPrepared"
          @row-dbl-click="onRowDblClick"
          @content-ready="carregouGrid"
          @exporting="onExporting">

        <DxRemoteOperations
            :filtering="true"
            :paging="true"
            :sorting="true"
            :summary="true"
            :grouping="false"
            :group-paging="false"
        />

        <DxColumnChooser :enabled="true"/>
        <DxColumnFixing :enabled="true"/>
        <DxFilterRow :visible="false" />

        <DxSelection mode="multiple"/>
        <DxExport
            :enabled="true"
            :allow-export-selected-data="true"/>
        <DxStateStoring
            :enabled="true"
            type="sessionStorage"
            storage-key="strTrackerEventsList"/>

        <DxGroupPanel :visible="true"/>
        <DxGrouping />


        <DxColumn
            data-field="id"
            sort-order="desc"
            caption="ID"
            data-type="number"
            alignment="right"
            :allowHeaderFiltering="false"/>

        <DxColumn
            data-field="name"
            caption="Nome"
            alignment="left"
            data-type="text"
            :allowHeaderFiltering="false"/>

        <DxColumn
            data-field="connectionStatus"
            caption="Status"
            data-type="text"
            alignment="right"
            :allowHeaderFiltering="false"/>

        <DxColumn
            data-field="ownerJid"
            caption="Proprietário"
            data-type="text"
            alignment="left"
            :allowHeaderFiltering="false"/>

        <DxColumn
            data-field="profileName"
            caption="Perfil"
            data-type="text"
            alignment="left"
            :allowHeaderFiltering="false"/>

        <DxPager
            :visible="true"
            :show-page-size-selector="true"
            :allowed-page-sizes="[10, 30, 50, 100]"
            :show-navigation-buttons="true"
            :show-info="true"/>

      </DxDataGrid>
    </div>


    <b-modal size="md"
             :title="zapInstanciaData.id ? `Editando Instância ${zapInstanciaData.id}` : 'Criar Nova Instância'"
             v-model="showModalInstancia" centered hide-footer>
      <div>
        <div class="card-body">

          <div class="row mb-2" v-if="updatingInst">
            <Loader v-if="updatingInst" style="min-height: 300px;">
            </Loader>
          </div>

          <div v-if="!updatingInst">
            <div class="row mb-2">

              <div class="col-md-12">
                <label for="nome">Nome</label>
                <div class="position-relative">
                  <input
                      id="nome"
                      type="text"
                      v-model="zapInstanciaData.nome"
                      class="form-control"
                      :disabled="zapInstanciaData.id"
                      :class="{'is-invalid': submittedInstancia && !zapInstanciaData.nome}"
                      placeholder="Nome"/>
                  <div v-if="submittedInstancia && !zapInstanciaData.nome" class="invalid-feedback">
                    <span>Campo Nome obrigatório e deve possuir apenas letras e números, favor corrigir.</span>
                  </div>
                </div>
              </div>
              <div class="col-md-6 text-center">
                <img v-if="qrCodeLogin"
                     :src="qrCodeLogin"
                     style="height: 300px;" alt="imagem_login"/>

              </div>
            </div>

            <div class="row mb-2 mt-2" v-if="submittedInstancia">
              <b-alert show dismissible variant="warning" >
                <i class="mdi mdi-alert me-2"></i>Após realizar login com telefone basta clicar em fechar ou atualizar a página (F5)
              </b-alert>
            </div>
          </div>



        </div>
        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalInstancia = false; atualizaDataList()">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Fechar
          </b-button>

          <b-button type="button" variant="danger" class="ms-1" v-if="zapInstanciaData.id" @click="deleteInstancia">
            <i class="bx bx-trash font-size-16 align-middle me-2"></i>
            Excluir
          </b-button>

          <b-button type="button" variant="success" class="ms-1" v-if="!zapInstanciaData.id" @click="confInstancia">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>
    </b-modal>




  </Layout>
</template>
